export default __webpack_public_path__ + "static/media/ct9uh-min.0034f728.png";